import { Component, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { RewardsService } from '../../../services/rewards.service';
import { Table } from 'primeng/table';
import { Dropdown } from "primeng/dropdown";
import { RoleService } from '../../../services/role.service';
import { Router, ActivatedRoute } from "@angular/router";
import { ConfirmationService, MessageService } from 'primeng/api';
import { TitleCasePipe } from '@angular/common';
import { LazyLoadEvent } from 'primeng/api';
import * as moment from "moment";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { TokenStorageService } from 'src/app/services/token-storage.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  templateUrl: './request-list.component.html',
  styleUrls: ['./request-list.component.scss'],
  styles: [`
    :host ::ng-deep .p-datatable-gridlines p-progressBar {
        width: 100%;
    }
    @media screen and (max-width: 960px) {
        :host ::ng-deep .p-datatable.p-datatable-customers.rowexpand-table .p-datatable-tbody > tr > td:nth-child(6) {
            display: flex;
        }
    }
  `],
  providers: [MessageService, ConfirmationService, TitleCasePipe, RewardsService]
})

export class RewardRequestListComponent implements OnInit, OnDestroy {

  private destroy$ = new Subject<void>();
  rid;
  rlid;
  rewardName;
  deleveryForm: FormGroup;
  markasDeliveredModal: boolean = false;
  deliveredModal: boolean = false;
  delivered_message: any;
  submitted = false;
  public hide: boolean = true;
  rewardlist: any;
  totalRecords: 0;
  errorMessage = '';
  loading: boolean;
  calvalue: Date;
  statuses: any[];
  dstatuses: any[];
  responsiveOptions: any[] = [
    {
      breakpoint: '1024px',
      numVisible: 5
    },
    {
      breakpoint: '768px',
      numVisible: 3
    },
    {
      breakpoint: '560px',
      numVisible: 1
    }
  ];
  displayImages: boolean;
  displayImages1: boolean;
  displayCustom: boolean;
  activeIndex: number = 0;
  public loggedInUser;
  public userId;
  public userRoleId;
  public rewardModule;
  public loggedInUserPermissions;
  public rewardPermissions: any[] = [];
  private lastTableLazyLoadEvent: LazyLoadEvent;
  @ViewChild("dt", { static: false }) public dt: Table;
  @ViewChild("pDropDownId", { static: false }) pDropDownId: Dropdown;
  @ViewChild("pDropDownId2", { static: false }) pDropDownId2: Dropdown;
 
  constructor(private rewardsService: RewardsService, private router: Router, private activatedRoute: ActivatedRoute, private formBuilder: FormBuilder, private roleService: RoleService, private messageService: MessageService, private tokenStorageService: TokenStorageService) { }

  ngOnInit() {
    this.loggedInUser = this.tokenStorageService.getUser();
    this.userId = this.loggedInUser.userdata.id;
    this.userRoleId = this.loggedInUser.userdata.role;
    this.rewardModule = "Rewards Management";
    this.loggedInUserPermissions = this.tokenStorageService.getUserPermissions();
    this.loggedInUserPermissions.forEach(permission => {
      if (permission.module == this.rewardModule) {
        let permissionObj = {
          moduleName: permission.module,
          status: permission.status,
          permission: permission.permission
        }
        this.rewardPermissions.push(permissionObj);
      }
    });
    if (this.rewardPermissions.length == 0) {
      this.router.navigateByUrl('/manage/dashboard')
    }
    this.rewardPermissions = this.rewardPermissions[0]['permission'];
    this.rid = this.activatedRoute.snapshot.params.id;
    this.dstatuses = [
      { label: 'Pending', value: 'Pending' },
      { label: 'On the Way', value: 'On the Way' },
      { label: 'Completed', value: 'Completed' },
      { label: 'Rejected', value: 'Rejected' },
      { label: 'Cancelled', value: 'Cancelled' }
    ];
    this.statuses = [
      { label: 'Pending', value: 'Pending' },
      { label: 'Delivered', value: 'Delivered' },
      { label: 'Approved', value: 'Approved' },
      { label: 'Rejected', value: 'Rejected' },
      { label: 'Cancelled', value: 'Cancelled' }
    ];
    this.deleveryForm = this.formBuilder.group(
    {
      comment: ["",[Validators.required]]
    });
  }

  get f() {
    return this.deleveryForm.controls;
  }

  loadRewards(event: LazyLoadEvent) {
    this.lastTableLazyLoadEvent = event;
    var query = "?filterByDisable=false";
    var pagenumber;
    var params = "";
    if (event.first == 0) {
      pagenumber = event.first + 1;
    } else {
      pagenumber = (event.first / event.rows) + 1;
    }
    if (event.filters != undefined && event.filters["player_name"] != undefined) {
      params += "&filterByPlayerName=" + event.filters["player_name"].value;
    }
    if (event.filters != undefined && event.filters["mobile_no"] != undefined) {
      params += "&filterByMobileNo=" + event.filters["mobile_no"].value;
    }
    if (event.filters != undefined && event.filters["created_at"] != undefined) {
      const createdAt = moment(event.filters["created_at"].value).format("YYYY-MM-DD");
      params += "&filterByCreatedAt=" + createdAt;
    }
    if (event.filters != undefined && event.filters["reward_name"] != undefined) {
      params += "&filterByRewardName=" + event.filters["reward_name"].value;
    }
    if (event.filters != undefined && event.filters["required_size"] != undefined) {
      params += "&filterByRequiredSize=" + event.filters["required_size"].value;
    }
     if (event.filters != undefined && event.filters["status"] != undefined) {
      params += "&filterByStatus=" + event.filters["status"].value;
    }
    if (event.filters != undefined && event.filters["delivery_status"] != undefined) {
      params += "&filterByDeliveryStatus=" + event.filters["delivery_status"].value;
    }
    if (event.filters != undefined && event.filters["approved_by"] != undefined) {
      params += "&filterByApprovedBy=" + event.filters["approved_by"].value;
    }
    if (event.filters != undefined && event.filters["email_id"] != undefined) {
      params += "&filterByEmailId=" + event.filters["email_id"].value;
    }
    if (event.filters != undefined && event.filters["state"] != undefined) {
      params += "&filterByState=" + event.filters["state"].value;
    }
    if (event.filters != undefined && event.filters["city"] != undefined) {
      params += "&filterByCity=" + event.filters["city"].value;
    }
    if (event.filters != undefined && event.filters["zipcode"] != undefined) {
      params += "&filterByZipcode=" + event.filters["zipcode"].value;
    }
    if (event.filters != undefined && event.filters["address"] != undefined) {
      params += "&filterByAddress=" + event.filters["address"].value;
    }
    if (params != undefined && params != "") {
      query += "&pageSize=" + event.rows + "&pageNumber=" + pagenumber + params;
    } else {
      query += "&pageSize=" + event.rows + "&pageNumber=" + pagenumber;
    }
    if (event.sortField != undefined && event.sortOrder != undefined) {
      var orderBy = "";
      if (event.sortOrder == 1) {
        orderBy = "DESC";
      } else {
        orderBy = "ASC";
      }
      query += "&sortBy=" + event.sortField + "&orderBy=" + orderBy;
    }
    var querystring = "filterByroleName=admin";
    this.roleService.searchRoleDetails(querystring).pipe(takeUntil(this.destroy$)).subscribe(data => {
      this.rewardsService.getRewardRequestList(this.rid,query).pipe(takeUntil(this.destroy$)).subscribe(data => {
        this.loading = false;
        this.rewardName = data.rewardname;
        this.rewardlist = data.data;
        this.totalRecords = data.totalCount;
        this.rewardlist.forEach(element => {
          element.created_at = new Date(element.created_at);
          element.updated_at = new Date(element.updated_at);
        });
      },
      err => {
        this.errorMessage = err.error.message;
      });
    },
    err => {
      this.errorMessage = err.error.message;
    });
  }

  clear() {
    this.dt.filter('', 'player_name', 'contains');
    this.dt.filter('', 'mobile_no', 'contains');
    this.dt.filter('', 'created_at', 'dateIs');
    this.dt.filter('', 'reward_name', 'contains');
    this.dt.filter('', 'required_size', 'contains');
    this.dt.filter('', 'status', 'contains');
    this.dt.filter('', 'delivery_status', 'contains');
    this.dt.filter('', 'approved_by', 'contains');
    this.dt.filter('', 'email_id', 'contains');
    this.dt.filter('', 'state', 'contains');
    this.dt.filter('', 'city', 'contains');
    this.dt.filter('', 'zipcode', 'contains');
    this.dt.filter('', 'address', 'contains');
    this.calvalue = null;
    this.pDropDownId.clear(null);
    if (this.pDropDownId) {
      this.pDropDownId.value = null;
    }
    this.pDropDownId2.clear(null);
    if (this.pDropDownId2) {
      this.pDropDownId2.value = null;
    }
  }

  getClassOf(status) {
    if (status == "Delivered") {
      return "bg-success text-white";
    } else if (status == "Approved") {
      return "bg-warning text-dark";
    } else if (status == "Pending") {
      return "bg-warning text-dark";
    } else {
      return "bg-danger text-white";
    }
  }

  mark_as_delivered(id) {
    this.markasDeliveredModal = true;
    this.rlid = id;
  }

  delivered_comment(id) {
    this.deliveredModal = true;
    this.rewardsService.getRewardMessage(id).pipe(takeUntil(this.destroy$)).subscribe((data) => {
      this.delivered_message = data[0].comment;
    },
    (err) => {
      this.errorMessage = err.error.message;
    });
  }

  onSubmit() {
    this.submitted = true;
    if (this.deleveryForm.invalid) {
      console.log("invalid");
      return;
    }
    console.log("valid");
    var deliveryData = this.deleveryForm.value;
    deliveryData['key'] = 'comment';
    deliveryData['value'] = this.deleveryForm.value.comment;
    deliveryData = JSON.stringify(deliveryData, null, 4);
    this.rewardsService.updateRewardMessage(this.rlid, deliveryData).pipe(takeUntil(this.destroy$)).subscribe(data => {
      this.messageService.add({ key: 'toastmsg', severity: 'success', summary: 'Successful', detail: 'Comment Added Successfully!!', life: 6000 });
      this.router.routeReuseStrategy.shouldReuseRoute = () => false;
      this.router.onSameUrlNavigation = "reload";
      this.router.navigate(['/manage/rewards/request-list/'+this.rid]);
    },
    ((err) => {
      this.messageService.add({ key: 'toastmsg', severity: 'error', summary: "Error", detail: err.error.message, life: 6000 });
    }));
  }

  addColumns() {
    this.hide = false;
  }

  removeColumns() {
    this.hide = true;
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

}